<template>
    <div>
        <v-container>
            <v-layout>
                <v-flex xs12 style="text-align: center">Voucher attached: {{conversions.vouchers}}</v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs6 style="text-align: center">ID reminder conversion activated: {{conversions.id_reminder.activated}}%</v-flex>
                <v-flex xs6 style="text-align: center">ID reminder total: {{conversions.id_reminder.reminded}}</v-flex>
            </v-layout>
        </v-container>
        <loading-component :value="loading"></loading-component>
        <DataTable
                ref="dataTable"
                title="Anas Stats"
                :url="api.ACTIONS.ANAS"
                :enable-edit="false"
                :enable-delete="false"
                :enable-add="false"/>
    </div>
</template>

<script>
    import DataTable from '@/components/wasilni/DataTable';
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        name: "FirstRidePax",
        title: 'First ride pax',
        components: {LoadingComponent, DataTable},
        data() {
            return {
                loading: false,
                conversions: {
                    id_reminder: {}
                }
            }
        },
        mounted() {
            this.axios.get('customer_care/anas_conversions')
                .then(res => this.conversions = res.data.data)
                .catch(err => console.log(err.message));
        }
    }
</script>

<style scoped>

</style>